export const generalSettingTranslation = {
  en: {
    home: "Home",
    Settings: "Settings",
    "General Settings": "General Settings",
    "Is Wathq CRS Enabled": "Is Wathq CRS Enabled",
    "Is Deny VPN": "Is Deny VPN",
    "Allow HTTP Access": "Allow HTTP Access",
    "Is SMS Enabled": "Is SMS Enabled",
    "Is IP Restrict": "Is IP Restrict",
    "Is Whatsapp Enabled": "Is Whatsapp Enabled",
    "Is Nafath Enabled": "Is Nafath Enabled",
    "Is Under Maintenance Enabled": "Is Under Maintenance Enabled",
    "Is Android Maintenance Enabled": "Is Android Maintenance Enabled",
    "Is IOS Maintenance Enabled": "Is IOS Maintenance Enabled",
    "Is Test Mode Enabled": "Is Test Mode Enabled",
    "Is Landing Website Enabled": "Is Landing Website Enabled",
    "Is ReCaptcha Enabled": "Is ReCaptcha Enabled",
    "Is Social Login Enabled": "Is Social Login Enabled",
    "Is Cloud Storage Enabled": "Is Cloud Storage Enabled",
    "Free Plan Platform Certificate": "Free Plan Platform Certificate",
    "Free-plan documents are signed with this certificate (.pfx / .p12 with its private key). Users on a paid plan sign with their own certificate. The file and password are stored securely and are never shown again.": "Free-plan documents are signed with this certificate (.pfx / .p12 with its private key). Users on a paid plan sign with their own certificate. The file and password are stored securely and are never shown again.",
    "Not configured": "Not configured",
    "Expired": "Expired",
    "File missing": "File missing",
    "Expires soon": "Expires soon",
    "Serial Number": "Serial Number",
    "Valid Until": "Valid Until",
    "days left": "days left",
    "No platform certificate is configured, so free-plan users cannot sign documents.": "No platform certificate is configured, so free-plan users cannot sign documents.",
    "The certificate file is missing on the server. Upload it again.": "The certificate file is missing on the server. Upload it again.",
    "Certificate File (.pfx / .p12)": "Certificate File (.pfx / .p12)",
    "Certificate Password": "Certificate Password",
    "Remove it? Free-plan signing stops until a new certificate is uploaded.": "Remove it? Free-plan signing stops until a new certificate is uploaded.",
    "Removing…": "Removing…",
    "Remove": "Remove",
    "Replace Certificate": "Replace Certificate",
    "Uploading…": "Uploading…",
    "Upload Certificate": "Upload Certificate",
    "Loading…": "Loading…",
    "Could not load the platform certificate.": "Could not load the platform certificate.",
    "The certificate could not be saved.": "The certificate could not be saved.",
    "The certificate could not be removed.": "The certificate could not be removed.",
    "Is LTV certificate Enabled": "Is LTV certificate Enabled",
    "Choose Password Reminder Days": "Choose Password Reminder Days",
    "Password Change Reminder Enabled": "Password Change Reminder Enabled",
    "SMS Endpoint": "SMS Endpoint",
    "SMS Username": "SMS Username",
    "SMS Password": "SMS Password",
    "SMS Sender": "SMS Sender",
    "Whatsapp Account": "Whatsapp Account",
    "SMP App Id": "SMP App Id",
    "Sendgrid Email": "Sendgrid Email",
    "Sendgrid Sender Email": "Sendgrid Sender Email",
    "Sendgrid API Key": "Sendgrid API Key",
    "Email Sender Name": "Email Sender Name",
    "Email Type": "Email Type",
    "Email Delivery Type": "Email Delivery Type",
    "SMTP Host": "SMTP Host",
    "SMTP Port": "SMTP Port",
    "SMTP Username": "SMTP Username",
    "SMTP Password": "SMTP Password",
    "SMTP Email": "SMTP Email",
    "SMTP Encryption Id": "SMTP Encryption Id",
    "Workflow Theme Logo": "Workflow Theme Logo",
    "Workflow Color (hex value)": "Workflow Color (hex value)",
    "Logo Watermark": "Logo Watermark",
    "Company Url": "Company Url",
    "Invoice Prefix": "Invoice Prefix",
    "Vat Percentage": "Vat Percentage",
    "Free Signatures": "Free Signatures",
    "Hourly Request Limit": "Hourly Request Limit",
    "Wrong Request Limit": "Wrong Request Limit",
    "No. of Minutes for Request Limit": "No. of Minutes for Request Limit",
    "No. of Limit for This Period": "No. of Limit for This Period",
    "API Usage Limits": "API Usage Limits",
    "Integration API Token Expiry (Days)":
      "Integration API Token Expiry (Days)",
    "Web App Session Timeout (Minutes)": "Web App Session Timeout (Minutes)",
    "HAAT VAT Number": "HAAT VAT Number",
    "HAAT Website": "HAAT Website",
    "HAAT Email": "HAAT Email",
    "HAAT Address": "HAAT Address",
    "ReCaptcha Site Key": "ReCaptcha Site Key",
    "Recaptcha Secret Key": "Recaptcha Secret Key",
    "Update Settings": "Update Settings",
    "System Controls": "System Controls",
    "Configuration Settings": "Configuration Settings",
    "Default Period of Certificate": "Default Period of Certificate",
    "Maximum File Size (MB)": "Maximum File Size (MB)",
    "Client Secret": "Client Secret",
    "Client ID": "Client ID",
    "Redirect URL": "Redirect URL",
    "TSI Type": "TSI Type",
    "Reference Prefix": "Reference Prefix",
    "Document download filename format": "Document download filename format",
    "Is Logo Watermark for PDF Enabled": "Is Logo Watermark for PDF Enabled",
    "SMS Settings": "SMS Settings",
    "SMTP Settings": "SMTP Settings",
    "SMTP Encryption": "SMTP Encryption",
    "POP Plain Port": "POP Plain Port",
    "POP TLS Port": "POP TLS Port",
    "IMAP Plain Port": "IMAP Plain Port",
    "IMAP TLS Port": "IMAP TLS Port",
    "SendGrid Settings": "SendGrid Settings",
    "Sendgrid SSL port": "Sendgrid SSL port",
    "Sendgrid TLS Port": "Sendgrid TLS Port",
    "Sendgrid Username": "Sendgrid Username",
    "Sendgrid Password": "Sendgrid Password",
    "Sendgrid Webhook URL": "Sendgrid Webhook URL",
    "Whatsapp Settings": "Whatsapp Settings",
    "Whatsapp Access Token": "Whatsapp Access Token",
    "Whatsapp Business Account ID": "Whatsapp Business Account ID",
    "Whatsapp Webhook Endpoint": "Whatsapp Webhook Endpoint",
    "Hyperpay Payment Gateway Settings": "Hyperpay Payment Gateway Settings",
    "Hyperpay Entity ID": "Hyperpay Entity ID",
    "Hyperpay Token": "Hyperpay Token",
    "Hyperpay Base URL": "Hyperpay Base URL",
    "Is Hyperpay Enabled": "Is Hyperpay Enabled",
    "Is Tamara Enabled": "Is Tamara Enabled",
    "Is Tabby Enabled": "Is Tabby Enabled",
    "Hyperpay Redirect URL": "Hyperpay Redirect URL",
    "Hyperpay Test URL": "Hyperpay Test URL",
    "Tamara Payment Gateway Settings": "Tamara Payment Gateway Settings",
    "Tamara API Token": "Tamara API Token",
    "Tamara API URL": "Tamara API URL",
    "Tamara Test URL": "Tamara Test URL",
    "Tamara Callback URL": "Tamara Callback URL",
    "Tabby Payment Gateway Settings": "Tabby Payment Gateway Settings",
    "Tabby API Key": "Tabby API Key",
    "Tabby API URL": "Tabby API URL",
    "Tabby Test URL": "Tabby Test URL",
    "Tabby Callback URL": "Tabby Callback URL",
    "Zatca Integration Settings": "Zatca Integration Settings",
    "Zatca Environment": "Zatca Environment",
    "Zatca Device UUID": "Zatca Device UUID",
    "Zatca OTP": "Zatca OTP",
    "ZATCA E-Invoicing": "ZATCA E-Invoicing",
    "Retry": "Retry",
    "Loading ZATCA settings…": "Loading ZATCA settings…",
    "Inactive": "Inactive",
    "Active": "Active",
    "Waiting for onboarding": "Waiting for onboarding",
    "Onboarded": "Onboarded",
    "Onboarding incomplete": "Onboarding incomplete",
    "Not onboarded": "Not onboarded",
    "B2C only: subscription invoices are issued as simplified tax invoices, signed with a QR code and reported to ZATCA when payment succeeds. Needs an onboarded device for the chosen environment (below).": "B2C only: subscription invoices are issued as simplified tax invoices, signed with a QR code and reported to ZATCA when payment succeeds. Needs an onboarded device for the chosen environment (below).",
    "Turn off": "Turn off",
    "Turn on": "Turn on",
    "Status": "Status",
    "B2C · Simplified": "B2C · Simplified",
    "Environment": "Environment",
    "Changing…": "Changing…",
    "Change": "Change",
    "✓ = already onboarded. Each environment keeps its own device and history; switching back continues where it stopped.": "✓ = already onboarded. Each environment keeps its own device and history; switching back continues where it stopped.",
    "Switch to Production? Every paid subscription will then be reported to ZATCA as a real tax invoice.": "Switch to Production? Every paid subscription will then be reported to ZATCA as a real tax invoice.",
    "Switch to Production": "Switch to Production",
    "Documents sent": "Documents sent",
    "None yet": "None yet",
    "Reported": "Reported",
    "Pending": "Pending",
    "Rejected": "Rejected",
    "Failed": "Failed",
    "ZATCA E-Invoicing (Seller)": "ZATCA E-Invoicing (Seller)",
    "HaatSign's seller details printed on every simplified tax invoice and submitted when onboarding the device. Use the Saudi national address.": "HaatSign's seller details printed on every simplified tax invoice and submitted when onboarding the device. Use the Saudi national address.",
    "Seller details are complete for ZATCA simplified tax invoices.": "Seller details are complete for ZATCA simplified tax invoices.",
    "Seller details are incomplete. Fill in the highlighted fields and save before onboarding.": "Seller details are incomplete. Fill in the highlighted fields and save before onboarding.",
    "Seller Name": "Seller Name",
    "VAT Number": "VAT Number",
    "Seller ID Type": "Seller ID Type",
    "Seller ID Number": "Seller ID Number",
    "Street Name": "Street Name",
    "Building Number": "Building Number",
    "Additional Number": "Additional Number",
    "District": "District",
    "City": "City",
    "Postal Code": "Postal Code",
    "Business Category": "Business Category",
    "Saving…": "Saving…",
    "Save Changes": "Save Changes",
    "ZATCA Device Onboarding": "ZATCA Device Onboarding",
    "Registers HaatSign as an e-invoicing device (EGS unit) with ZATCA for simplified (B2C) invoices. Needed once per environment: sandbox, simulation and production each need their own onboarding.": "Registers HaatSign as an e-invoicing device (EGS unit) with ZATCA for simplified (B2C) invoices. Needed once per environment: sandbox, simulation and production each need their own onboarding.",
    "Device": "Device",
    "Onboarded at": "Onboarded at",
    "Certificate expires": "Certificate expires",
    "Invoice counter (ICV)": "Invoice counter (ICV)",
    "Simplified invoice": "Simplified invoice",
    "Credit note": "Credit note",
    "Debit note": "Debit note",
    "This device has already signed documents and cannot be replaced; replacing it would break the invoice hash chain.": "This device has already signed documents and cannot be replaced; replacing it would break the invoice hash chain.",
    "The device has a compliance certificate but onboarding has not finished yet.": "The device has a compliance certificate but onboarding has not finished yet.",
    "Retrying…": "Retrying…",
    "Retry without new OTP": "Retry without new OTP",
    "Replace device (it has not signed any documents yet)": "Replace device (it has not signed any documents yet)",
    "Replace device": "Replace device",
    "Onboard device": "Onboard device",
    "Sandbox uses ZATCA's developer portal; enter the test OTP (for example 123345).": "Sandbox uses ZATCA's developer portal; enter the test OTP (for example 123345).",
    "Generate an OTP for this environment in the Fatoora portal (fatoora.zatca.gov.sa) and use it right away — it expires quickly and works only once.": "Generate an OTP for this environment in the Fatoora portal (fatoora.zatca.gov.sa) and use it right away — it expires quickly and works only once.",
    "OTP": "OTP",
    "Onboarding… this can take a minute": "Onboarding… this can take a minute",
    "Onboard with ZATCA": "Onboard with ZATCA",
    "Save complete seller details first.": "Save complete seller details first.",
    "Replace device (test environment — starts a new invoice hash chain)": "Replace device (test environment — starts a new invoice hash chain)",
    "This test device has already signed invoices. The new device starts a new hash chain, and invoices still waiting to be reported may be rejected by ZATCA.": "This test device has already signed invoices. The new device starts a new hash chain, and invoices still waiting to be reported may be rejected by ZATCA.",
    "Required or invalid": "Required or invalid",
    "Sandbox (developer portal test)": "Sandbox (developer portal test)",
    "Simulation (pre-production with your real details)": "Simulation (pre-production with your real details)",
    "Production (live)": "Production (live)",
    "DSG Link": "DSG Link",
    "Hyperpay Base URL is required": "Hyperpay Base URL is required",
    "Hyperpay Base URL must be a valid URL":
      "Hyperpay Base URL must be a valid URL",
    "Hyperpay Redirect URL is required": "Hyperpay Redirect URL is required",
    "Hyperpay Redirect URL must be a valid URL":
      "Hyperpay Redirect URL must be a valid URL",
    "Please fix Hyperpay URL validation errors":
      "Please fix Hyperpay URL validation errors",
    "Recaptcha Settings": "Recaptcha Settings",
    "Recaptcha Version": "Recaptcha Version",
    "Recaptcha Owner": "Recaptcha Owner",
    "View Workflow Theme Logo": "View Workflow Theme Logo",
    "Maintenance Image (EN)": "Maintenance Image (EN)",
    "Maintenance Image (AR)": "Maintenance Image (AR)",
    "Page Not Found Image": "Page Not Found Image",
    "View Logo Watermark": "View Logo Watermark",
    "View Maintenance Image (EN)": "View Maintenance Image (EN)",
    "View Maintenance Image (AR)": "View Maintenance Image (AR)",
    "Blacklist Restricted IP": "Blacklist Restricted IP",
    "Blacklist Restricted Country": "Blacklist Restricted Country",
    "Enter IP Addresses": "Enter IP Addresses",
    "ReCaptcha v2 Site Key": "ReCaptcha v2 Site Key",
    "ReCaptcha v2 Secret Key": "ReCaptcha v2 Secret Key",
    "ReCaptcha v3 Site Key": "ReCaptcha v3 Site Key",
    "ReCaptcha v3 Secret Key": "ReCaptcha v3 Secret Key",
    "Password Security": "Password Security",
    "Show Password Rules": "Show Password Rules",
    "Password Rules": "Password Rules",
    "Password Strength": "Password Strength",
    Basic: "Basic",
    Medium: "Medium",
    Strong: "Strong",
    Custom: "Custom",
    "Enable password expiration": "Enable password expiration",
    "Days until password expires": "Days until password expires",
    "Password Requirements": "Password Requirements",
    "Must be at least 6 characters long.":
      "Must be at least 6 characters long.",
    "Must be at least 7 characters long.":
      "Must be at least 7 characters long.",
    "Must be at least 9 characters long.":
      "Must be at least 9 characters long.",
    "Must contain at least one uppercase letter.":
      "Must contain at least one uppercase letter.",
    "Must contain at least one lowercase letter.":
      "Must contain at least one lowercase letter.",
    "Must contain at least one number OR one special character.":
      "Must contain at least one number OR one special character.",
    "Must contain at least one number.": "Must contain at least one number.",
    "Must contain at least one special character.":
      "Must contain at least one special character.",
    "Custom settings": "Custom settings",
    "Minimum password length (6-30 characters)":
      "Minimum password length (6-30 characters)",
    "Minimum password age (0 or more days)":
      "Minimum password age (0 or more days)",
    "Passwords must include": "Passwords must include",
    "At least one uppercase letter": "At least one uppercase letter",
    "At least one lowercase letter": "At least one lowercase letter",
    "At least one digit": "At least one digit",
    "At least one special character": "At least one special character",
    Cancel: "Cancel",
    Save: "Save",
  },
  ar: {
    home: "الرئيسية",
    Settings: "الإعدادات",
    "General Settings": "الإعدادات العامة",
    "Is Wathq CRS Enabled": "تفعيل CRS في واثق",
    "Is Deny VPN": "هل تم رفض VPN",
    "Allow HTTP Access": "السماح بالوصول عبر HTTP",
    "Is SMS Enabled": " هل تم تمكين الرسائل القصيرة",
    "Is IP Restrict": " هل تم تقييد IP",
    "Is Whatsapp Enabled": "هل تم تفعيل واتساب؟",
    "Is Nafath Enabled": "هل تم تمكين نفاذ",
    "Is Under Maintenance Enabled": "هل تم تمكين تحت الصيانة",
    "Is Android Maintenance Enabled": "هل تم تفعيل صيانة أندرويد؟",
    "Is IOS Maintenance Enabled": "هل تم تمكين صيانة IOS",
    "Is Test Mode Enabled": "هل تم تمكين وضع الاختبار",
    "Is Landing Website Enabled": "هل تم تمكين موقع الهبوط",
    "Is ReCaptcha Enabled": "هل تم تمكين ReCaptcha",
    "Is Social Login Enabled": "هل تم تفعيل تسجيل الدخول عبر الشبكات الاجتماعية",
    "Is Cloud Storage Enabled": "هل تم تفعيل التخزين السحابي",
    "Free Plan Platform Certificate": "شهادة المنصة للخطة المجانية",
    "Free-plan documents are signed with this certificate (.pfx / .p12 with its private key). Users on a paid plan sign with their own certificate. The file and password are stored securely and are never shown again.": "تُوقَّع مستندات الخطة المجانية بهذه الشهادة (ملف ‎.pfx أو ‎.p12 مع مفتاحها الخاص). يوقّع مستخدمو الخطط المدفوعة بشهاداتهم الخاصة. يُحفظ الملف وكلمة المرور بشكل آمن ولا يُعرضان مرة أخرى.",
    "Not configured": "غير مُعدّة",
    "Expired": "منتهية الصلاحية",
    "File missing": "الملف مفقود",
    "Expires soon": "تنتهي قريباً",
    "Serial Number": "الرقم التسلسلي",
    "Valid Until": "صالحة حتى",
    "days left": "يوماً متبقياً",
    "No platform certificate is configured, so free-plan users cannot sign documents.": "لا توجد شهادة منصة مُعدّة، لذلك لا يستطيع مستخدمو الخطة المجانية توقيع المستندات.",
    "The certificate file is missing on the server. Upload it again.": "ملف الشهادة غير موجود على الخادم. ارفعه مرة أخرى.",
    "Certificate File (.pfx / .p12)": "ملف الشهادة (‎.pfx / ‎.p12)",
    "Certificate Password": "كلمة مرور الشهادة",
    "Remove it? Free-plan signing stops until a new certificate is uploaded.": "هل تريد حذفها؟ سيتوقف التوقيع في الخطة المجانية حتى رفع شهادة جديدة.",
    "Removing…": "جارٍ الحذف…",
    "Remove": "حذف",
    "Replace Certificate": "استبدال الشهادة",
    "Uploading…": "جارٍ الرفع…",
    "Upload Certificate": "رفع الشهادة",
    "Loading…": "جارٍ التحميل…",
    "Could not load the platform certificate.": "تعذر تحميل شهادة المنصة.",
    "The certificate could not be saved.": "تعذر حفظ الشهادة.",
    "The certificate could not be removed.": "تعذر حذف الشهادة.",
    "Is LTV certificate Enabled": "هل تم تمكين شهادة LTV",
    "Choose Password Reminder Days": "اختر أيام تذكير كلمة المرور",
    "Password Change Reminder Enabled": "تمكين تذكير تغيير كلمة المرور",
    "SMS Endpoint": "نقطة نهاية الرسائل القصيرة",
    "SMS Username": "اسم مستخدم الرسائل القصيرة",
    "SMS Password": "كلمة مرور الرسائل القصيرة",
    "SMS Sender": "مرسل الرسائل القصيرة",
    "Whatsapp Account": "حساب Whatsapp",
    "SMP App Id": "معرف تطبيق SMP",
    "Sendgrid Email": "البريد الإلكتروني لـ Sendgrid",
    "Sendgrid Sender Email": "البريد الإلكتروني للمرسل لـ Sendgrid",
    "Sendgrid API Key": "مفتاح API لـ Sendgrid",
    "Email Sender Name": "اسم مرسل البريد الإلكتروني",
    "Email Type": "نوع البريد الإلكتروني",
    "Email Delivery Type": "نوع تسليم البريد الإلكتروني",
    "SMTP Host": "مضيف SMTP",
    "SMTP Port": "منفذ SMTP",
    "SMTP Username": "اسم مستخدم SMTP",
    "SMTP Password": "كلمة مرور SMTP",
    "SMTP Email": "البريد الإلكتروني لـ SMTP",
    "SMTP Encryption Id": "معرف تشفير SMTP",
    "Workflow Theme Logo": "شعار موضوع سير العمل",
    "Workflow Color (hex value)": " لون سير العمل (قيمة hex)",
    "Logo Watermark": "علامة مائية للشعار",
    "Company Url": "رابط الشركة",
    "Invoice Prefix": "بادئة الفاتورة",
    "Vat Percentage": "نسبة ضريبة القيمة المضافة",
    "Free Signatures": "التوقيعات المجانية",
    "Hourly Request Limit": "الحد الأقصى للطلبات في الساعة",
    "Wrong Request Limit": "حد الطلبات الخاطئة",
    "No. of Minutes for Request Limit": "عدد الدقائق لحد الطلبات",
    "No. of Limit for This Period": "عدد الحد لهذه الفترة",
    "API Usage Limits": "حدود استخدام الواجهة البرمجية",
    "Integration API Token Expiry (Days)":
      "انتهاء صلاحية رمز الواجهة البرمجية (بالأيام)",
    "Web App Session Timeout (Minutes)": "مهلة جلسة تطبيق الويب (بالدقائق)",
    "HAAT VAT Number": "الرقم الضريبي لـ هات",
    "HAAT Website": "موقع هات",
    "HAAT Email": "بريد هات الإلكتروني",
    "HAAT Address": "عنوان هات",
    "ReCaptcha Site Key": "مفتاح موقع ReCaptcha",
    "Recaptcha Secret Key": "مفتاح ReCaptcha السري",
    "Update Settings": "تحديث الإعدادات",
    "System Controls": "ضوابط النظام",
    "Configuration Settings": "إعدادات التكوين",
    "Default Period of Certificate": "الفترة الافتراضية للشهادة",
    "Maximum File Size (MB)": "أقصى حجم ملف (ميغابايت)",
    "Client Secret": "سر العميل",
    "Client ID": "معرّف العميل",
    "Redirect URL": "رابط إعادة التوجيه",
    "TSI Type": "نوع TSI",
    "Reference Prefix": "بادئة المرجع",
    "Document download filename format": "تنسيق اسم ملف تنزيل المستند",
    "Is Logo Watermark for PDF Enabled":
      "هل تم تمكين علامة مائية للشعار في PDF",
    "SMS Settings": "إعدادات الرسائل القصيرة",
    "SMTP Settings": "إعدادات SMTP",
    "SMTP Encryption": "تشفير SMTP",
    "POP Plain Port": "منفذ POP Plain",
    "POP TLS Port": "منفذ POP TLS",
    "IMAP Plain Port": "منفذ IMAP Plain",
    "IMAP TLS Port": "منفذ IMAP TLS",
    "SendGrid Settings": "إعدادات SendGrid",
    "Sendgrid SSL port": "منفذ Sendgrid SSL",
    "Sendgrid TLS Port": "منفذ Sendgrid TLS",
    "Sendgrid Username": "اسم مستخدم Sendgrid",
    "Sendgrid Password": "كلمة مرور Sendgrid",
    "Sendgrid Webhook URL": "رابط Webhook لـ Sendgrid",
    "Whatsapp Settings": "إعدادات Whatsapp",
    "Whatsapp Access Token": "رمز وصول Whatsapp",
    "Whatsapp Business Account ID": "معرف حساب Whatsapp للأعمال",
    "Whatsapp Webhook Endpoint": "نقطة نهاية Webhook لـ Whatsapp",
    "Hyperpay Payment Gateway Settings": "إعدادات بوابة الدفع Hyperpay",
    "Hyperpay Entity ID": "معرف كيان Hyperpay",
    "Hyperpay Token": "رمز Hyperpay",
    "Hyperpay Base URL": "رابط Hyperpay الأساسي",
    "Is Hyperpay Enabled": "هل تم تفعيل بوابة الدفع Hyperpay",
    "Is Tamara Enabled": "هل تم تفعيل تمارا",
    "Is Tabby Enabled": "هل تم تفعيل تابي",
    "Hyperpay Redirect URL": "رابط إعادة التوجيه لـ Hyperpay",
    "Hyperpay Test URL": "رابط اختبار Hyperpay",
    "Tamara Payment Gateway Settings": "إعدادات بوابة الدفع تمارا",
    "Tamara API Token": "رمز API لتمارا",
    "Tamara API URL": "رابط API لتمارا",
    "Tamara Test URL": "رابط اختبار تمارا",
    "Tamara Callback URL": "رابط استدعاء تمارا",
    "Tabby Payment Gateway Settings": "إعدادات بوابة الدفع تابي",
    "Tabby API Key": "مفتاح API لتابي",
    "Tabby API URL": "رابط API لتابي",
    "Tabby Test URL": "رابط اختبار تابي",
    "Tabby Callback URL": "رابط استدعاء تابي",
    "Zatca Integration Settings": "إعدادات تكامل زاتكا",
    "Zatca Environment": "بيئة زاتكا",
    "Zatca Device UUID": "معرف جهاز زاتكا",
    "Zatca OTP": "رمز OTP لزاتكا",
    "ZATCA E-Invoicing": "الفوترة الإلكترونية (زاتكا)",
    "Retry": "إعادة المحاولة",
    "Loading ZATCA settings…": "جارٍ تحميل إعدادات زاتكا…",
    "Inactive": "غير مفعّل",
    "Active": "مفعّل",
    "Waiting for onboarding": "بانتظار تسجيل الجهاز",
    "Onboarded": "مسجّل",
    "Onboarding incomplete": "التسجيل غير مكتمل",
    "Not onboarded": "غير مسجّل",
    "B2C only: subscription invoices are issued as simplified tax invoices, signed with a QR code and reported to ZATCA when payment succeeds. Needs an onboarded device for the chosen environment (below).": "للأفراد (B2C) فقط: تُصدر فواتير الاشتراكات كفواتير ضريبية مبسطة موقّعة برمز QR ويتم الإبلاغ عنها إلى زاتكا عند نجاح الدفع. يتطلب جهازًا مسجّلًا للبيئة المختارة (أدناه).",
    "Turn off": "إيقاف",
    "Turn on": "تشغيل",
    "Status": "الحالة",
    "B2C · Simplified": "B2C · مبسطة",
    "Environment": "البيئة",
    "Changing…": "جارٍ التغيير…",
    "Change": "تغيير",
    "✓ = already onboarded. Each environment keeps its own device and history; switching back continues where it stopped.": "✓ = مسجّل مسبقًا. لكل بيئة جهازها وسجلها الخاص؛ والعودة إليها تُكمل من حيث توقفت.",
    "Switch to Production? Every paid subscription will then be reported to ZATCA as a real tax invoice.": "التبديل إلى بيئة الإنتاج؟ سيتم بعدها الإبلاغ عن كل اشتراك مدفوع إلى زاتكا كفاتورة ضريبية فعلية.",
    "Switch to Production": "التبديل إلى الإنتاج",
    "Documents sent": "المستندات المرسلة",
    "None yet": "لا يوجد بعد",
    "Reported": "تم الإبلاغ",
    "Pending": "قيد الانتظار",
    "Rejected": "مرفوض",
    "Failed": "فشل",
    "ZATCA E-Invoicing (Seller)": "الفوترة الإلكترونية (زاتكا) - البائع",
    "HaatSign's seller details printed on every simplified tax invoice and submitted when onboarding the device. Use the Saudi national address.": "بيانات هات ساين كبائع تظهر في كل فاتورة ضريبية مبسطة وتُرسل عند تسجيل الجهاز. استخدم العنوان الوطني السعودي.",
    "Seller details are complete for ZATCA simplified tax invoices.": "بيانات البائع مكتملة للفواتير الضريبية المبسطة.",
    "Seller details are incomplete. Fill in the highlighted fields and save before onboarding.": "بيانات البائع غير مكتملة. أكمل الحقول المطلوبة واحفظها قبل تسجيل الجهاز.",
    "Seller Name": "اسم البائع",
    "VAT Number": "الرقم الضريبي",
    "Seller ID Type": "نوع معرّف البائع",
    "Seller ID Number": "رقم معرّف البائع",
    "Street Name": "اسم الشارع",
    "Building Number": "رقم المبنى",
    "Additional Number": "الرقم الإضافي",
    "District": "الحي",
    "City": "المدينة",
    "Postal Code": "الرمز البريدي",
    "Business Category": "فئة النشاط",
    "Saving…": "جارٍ الحفظ…",
    "Save Changes": "حفظ التغييرات",
    "ZATCA Device Onboarding": "تسجيل جهاز زاتكا",
    "Registers HaatSign as an e-invoicing device (EGS unit) with ZATCA for simplified (B2C) invoices. Needed once per environment: sandbox, simulation and production each need their own onboarding.": "يسجّل هات ساين كجهاز فوترة إلكترونية (وحدة EGS) لدى زاتكا للفواتير المبسطة (B2C). مطلوب مرة واحدة لكل بيئة: التجريبية والمحاكاة والإنتاج لكل منها تسجيل مستقل.",
    "Device": "الجهاز",
    "Onboarded at": "تاريخ التسجيل",
    "Certificate expires": "انتهاء الشهادة",
    "Invoice counter (ICV)": "عدّاد الفواتير (ICV)",
    "Simplified invoice": "فاتورة مبسطة",
    "Credit note": "إشعار دائن",
    "Debit note": "إشعار مدين",
    "This device has already signed documents and cannot be replaced; replacing it would break the invoice hash chain.": "وقّع هذا الجهاز مستندات بالفعل ولا يمكن استبداله؛ فاستبداله سيكسر سلسلة تجزئة الفواتير.",
    "The device has a compliance certificate but onboarding has not finished yet.": "لدى الجهاز شهادة امتثال لكن التسجيل لم يكتمل بعد.",
    "Retrying…": "جارٍ إعادة المحاولة…",
    "Retry without new OTP": "إعادة المحاولة دون رمز جديد",
    "Replace device (it has not signed any documents yet)": "استبدال الجهاز (لم يوقّع أي مستندات بعد)",
    "Replace device": "استبدال الجهاز",
    "Onboard device": "تسجيل الجهاز",
    "Sandbox uses ZATCA's developer portal; enter the test OTP (for example 123345).": "تستخدم البيئة التجريبية بوابة المطورين لدى زاتكا؛ أدخل رمز الاختبار (مثل 123345).",
    "Generate an OTP for this environment in the Fatoora portal (fatoora.zatca.gov.sa) and use it right away — it expires quickly and works only once.": "أنشئ رمز OTP لهذه البيئة من بوابة فاتورة (fatoora.zatca.gov.sa) واستخدمه فورًا — فهو ينتهي سريعًا ويُستخدم مرة واحدة فقط.",
    "OTP": "رمز OTP",
    "Onboarding… this can take a minute": "جارٍ التسجيل… قد يستغرق ذلك دقيقة",
    "Onboard with ZATCA": "التسجيل لدى زاتكا",
    "Save complete seller details first.": "احفظ بيانات البائع كاملة أولًا.",
    "Replace device (test environment — starts a new invoice hash chain)": "استبدال الجهاز (بيئة اختبار — يبدأ سلسلة تجزئة فواتير جديدة)",
    "This test device has already signed invoices. The new device starts a new hash chain, and invoices still waiting to be reported may be rejected by ZATCA.": "وقّع جهاز الاختبار هذا فواتير بالفعل. سيبدأ الجهاز الجديد سلسلة تجزئة جديدة، وقد ترفض زاتكا الفواتير التي لم يتم الإبلاغ عنها بعد.",
    "Required or invalid": "مطلوب أو غير صالح",
    "Sandbox (developer portal test)": "التجريبية (بوابة المطورين)",
    "Simulation (pre-production with your real details)": "المحاكاة (ما قبل الإنتاج ببياناتك الفعلية)",
    "Production (live)": "الإنتاج (مباشر)",
    "DSG Link": "رابط DSG",
    "Hyperpay Base URL is required": "رابط Hyperpay الأساسي مطلوب",
    "Hyperpay Base URL must be a valid URL":
      "يجب أن يكون رابط Hyperpay الأساسي رابطاً صالحاً",
    "Hyperpay Redirect URL is required": "رابط إعادة التوجيه لـ Hyperpay مطلوب",
    "Hyperpay Redirect URL must be a valid URL":
      "يجب أن يكون رابط إعادة التوجيه لـ Hyperpay رابطاً صالحاً",
    "Please fix Hyperpay URL validation errors":
      "يرجى إصلاح أخطاء التحقق من روابط Hyperpay",
    "Recaptcha Settings": "إعدادات Recaptcha",
    "Recaptcha Version": "إصدار Recaptcha",
    "Recaptcha Owner": "مالك Recaptcha",
    "View Workflow Theme Logo": "عرض شعار موضوع سير العمل",
    "View Logo Watermark": "عرض علامة مائية للشعار",
    "Maintenance Image (EN)": "صورة الصيانة (EN)",
    "Maintenance Image (AR)": "صورة الصيانة (AR)",
    "Page Not Found Image": "صورة الصفحة غير موجودة",
    "View Maintenance Image (EN)": "عرض صورة الصيانة (EN)",
    "View Maintenance Image (AR)": "عرض صورة الصيانة (AR)",
    "Blacklist Restricted IP": "قائمة عناوين IP المقيدة",
    "Blacklist Restricted Country": "قائمة البلدان المقيدة",
    "Enter IP Addresses": "أدخل عناوين IP",
    "ReCaptcha v2 Site Key": "مفتاح موقع ReCaptcha v2",
    "ReCaptcha v2 Secret Key": "مفتاح ReCaptcha v2 السري",
    "ReCaptcha v3 Site Key": "مفتاح موقع ReCaptcha v3",
    "ReCaptcha v3 Secret Key": "مفتاح ReCaptcha v3 السري",
    "Password Security": "أمان كلمة المرور",
    "Show Password Rules": "عرض قواعد كلمة المرور",
    "Password Rules": "قواعد كلمة المرور",
    "Password Strength": "قوة كلمة المرور",
    Basic: "أساسي",
    Medium: "متوسط",
    Strong: "قوي",
    Custom: "مخصص",
    "Enable password expiration": "تفعيل انتهاء صلاحية كلمة المرور",
    "Days until password expires": "أيام حتى انتهاء صلاحية كلمة المرور",
    "Password Requirements": "متطلبات كلمة المرور",
    "Must be at least 6 characters long.": "يجب أن يكون 6 أحرف على الأقل.",
    "Must be at least 7 characters long.": "يجب أن يكون 7 أحرف على الأقل.",
    "Must be at least 9 characters long.": "يجب أن يكون 9 أحرف على الأقل.",
    "Must contain at least one uppercase letter.":
      "يجب أن يحتوي على حرف كبير واحد على الأقل.",
    "Must contain at least one lowercase letter.":
      "يجب أن يحتوي على حرف صغير واحد على الأقل.",
    "Must contain at least one number OR one special character.":
      "يجب أن يحتوي على رقم واحد أو حرف خاص واحد على الأقل.",
    "Must contain at least one number.": "يجب أن يحتوي على رقم واحد على الأقل.",
    "Must contain at least one special character.":
      "يجب أن يحتوي على حرف خاص واحد على الأقل.",
    "Custom settings": "الإعدادات المخصصة",
    "Minimum password length (6-30 characters)":
      "الحد الأدنى لطول كلمة المرور (6-30 حرفاً)",
    "Minimum password age (0 or more days)":
      "الحد الأدنى لعمر كلمة المرور (0 أو أكثر من الأيام)",
    "Passwords must include": "يجب أن تتضمن كلمة المرور",
    "At least one uppercase letter": "حرف كبير واحد على الأقل",
    "At least one lowercase letter": "حرف صغير واحد على الأقل",
    "At least one digit": "رقم واحد على الأقل",
    "At least one special character": "حرف خاص واحد على الأقل",
    Cancel: "إلغاء",
    Save: "حفظ",
  },
};
